import { ISearchFacets } from "@shared/lib/types/briefInfluencerV2";
import { SearchMultiSelectFilter } from "@shared/ui/filters/SearchMultiSelectFilter";
import { useBriefInfluencerFilterStore } from "@widgets/CampaignBrief/store/useBriefInfluencerFilterStore";

interface BriefPocFilterV2Props {
  confirm: () => void;
  close: () => void;
  pocOptions: ISearchFacets["assignedPricingPocV2"];
  before?: React.ReactNode;
}

export function BriefPocFilterV2({
  confirm,
  close,
  pocOptions,
  before,
}: BriefPocFilterV2Props) {
  const {
    feFilters: filters,
    setFilters,
    saveFilters,
  } = useBriefInfluencerFilterStore();

  const pocSelectOptions =
    pocOptions?.map((poc) => ({
      label: `${poc.user.firstName} ${poc.user.lastName}`,
      value: poc._id,
    })) ?? [];

  const handleApply = (selectedValues: string[]) => {
    setFilters({
      ...filters,
      assignedPricingPocV2:
        selectedValues.length > 0 ? selectedValues : undefined,
    });
    saveFilters();
  };

  return (
    <SearchMultiSelectFilter
      confirm={confirm}
      close={close}
      before={before}
      options={pocSelectOptions}
      selectedValues={filters.assignedPricingPocV2 || []}
      onApply={handleApply}
      searchPlaceholder="Search pricing POC"
    />
  );
}
